import { useState } from 'react'
import Captcha from '../Captcha'
import Button from '@talkdesk/cobalt-react-button'
import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'

const SecureForm = ({
  children,
  submitLabel,
  siteKey,
  disabledForm,
  onSubmit,
  onExecuteRecaptcha,
  isFormValid,
  isDanger = false,
}) => {
  const [recaptchaInstance, setRecaptchaInstance] = useState(null)

  const handleExecuteRecaptcha = () => {
    onExecuteRecaptcha()
    recaptchaInstance.execute()
  }

  const isSubmitDisabled = disabledForm || !isFormValid || !recaptchaInstance

  const handleFormSubmit = (event) => {
    event.preventDefault()
    if (isSubmitDisabled) {
      return
    }
    handleExecuteRecaptcha()
  }

  return (
    <Box paddingY='2' width='100%'>
      <form onSubmit={handleFormSubmit}>
        {children}
        <Flex direction='column' gap='2'>
          <Captcha
            siteKey={siteKey}
            instance={recaptchaInstance}
            onRecaptchaRendered={setRecaptchaInstance}
            onSubmit={onSubmit}
          />
          <Box paddingY='2' width='100%'>
            <Button
              htmlType='submit'
              disabled={isSubmitDisabled}
              shape='full-width'
              type={isDanger ? 'danger' : 'primary'}
            >
              {submitLabel}
            </Button>
          </Box>
        </Flex>
      </form>
    </Box>
  )
}

export default SecureForm
